import React from "react";
import { Moon, Sun, FileDown, FlaskConical, Loader2 } from "lucide-react";
import { COURSES } from "@/data";

export default function Navbar({ course, setCourse, theme, toggleTheme, onPdf, pdfBusy, pdfLabel }) {
  return (
    <header className="topbar" data-testid="topbar">
      <div className="topbar-inner">
        <div className="brand">
          <div className="brand-mark"><FlaskConical size={18} /></div>
          <div className="brand-text">
            <span className="brand-title">Vize Laboratuvarı</span>
            <span className="brand-sub">Kimya Öğretmenliği · Çalışma Platformu</span>
          </div>
        </div>

        <div className="course-switch" role="tablist" data-testid="course-switch">
          {Object.values(COURSES).map((c) => (
            <button
              key={c.key}
              role="tab"
              aria-selected={course === c.key}
              data-testid={`course-tab-${c.key}`}
              className={`course-tab ${course === c.key ? "active" : ""}`}
              data-c={c.key}
              onClick={() => setCourse(c.key)}
            >
              <span className="course-code">{c.code}</span>
              <span className="course-name">{c.short}</span>
            </button>
          ))}
        </div>

        <div className="topbar-actions">
          <button className="btn btn-accent" onClick={onPdf} disabled={pdfBusy} data-testid="topbar-pdf-btn" title={pdfLabel}>
            {pdfBusy ? <Loader2 size={16} className="spin" /> : <FileDown size={16} />}
            <span className="hide-sm">{pdfBusy ? "Hazırlanıyor…" : "Aktif İçeriği PDF İndir"}</span>
          </button>
          <button className="btn btn-icon" onClick={toggleTheme} aria-label="Tema değiştir" data-testid="theme-toggle">
            {theme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
          </button>
        </div>
      </div>
    </header>
  );
}
